import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { SEOHead, BreadcrumbSchema } from "@/components/SEOHead";

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead title="Privacy Policy | OnwardFlighTickets" description="How OnwardFlighTickets collects, uses, and protects your personal data." path="/privacy" />
      <BreadcrumbSchema items={[{ name: "Home", url: "https://onwardflightickets.com" }, { name: "Privacy Policy", url: "https://onwardflightickets.com/privacy" }]} />
      <Header />
      <main className="max-w-3xl mx-auto px-4 py-16" data-testid="privacy-page">
        <h1 className="font-['Outfit'] text-3xl font-bold text-[#1e293b] mb-8">Privacy Policy</h1>
        <div className="prose prose-sm max-w-none text-[#475569] space-y-6">
          <section>
            <h2 className="font-['Outfit'] text-lg font-semibold text-[#1e293b]">1. Information We Collect</h2>
            <p>We collect passenger name, email address, and flight preferences when you create a reservation. Payment information is processed securely and not stored on our servers.</p>
          </section>
          <section>
            <h2 className="font-['Outfit'] text-lg font-semibold text-[#1e293b]">2. How We Use Your Information</h2>
            <p>Your information is used solely to generate flight reservation documents, send confirmation emails, and provide customer support. We do not sell or share your data with third parties.</p>
          </section>
          <section>
            <h2 className="font-['Outfit'] text-lg font-semibold text-[#1e293b]">3. Data Retention</h2>
            <p>Reservation data is retained for 30 days after the reservation expires. After this period, personal data is automatically deleted from our systems.</p>
          </section>
          <section>
            <h2 className="font-['Outfit'] text-lg font-semibold text-[#1e293b]">4. Security</h2>
            <p>We use industry-standard encryption (SSL/TLS) for all data transmission. Access to personal data is restricted to authorized personnel only.</p>
          </section>
          <section>
            <h2 className="font-['Outfit'] text-lg font-semibold text-[#1e293b]">5. Contact</h2>
            <p>For privacy inquiries, email us at privacy@onwardflightickets.com.</p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}
